module.exports = __webpack_public_path__ + "media/index.15a58a02.mp4";